/* External dependencies */
import { Container, Div, Text } from 'atomize';
import { Link, Trans } from 'gatsby-plugin-react-i18next';
import React, { useState } from 'react';

/* Local dependencies */
import DownloadAppBanner from '../../../../components/website/downloadAppBanner/DownloadAppBanner';
import SvgMedcheckLogoBlack from '../../../../svg/SvgMedchekLogoBlack';
import SvgMedcheckLogo from '../../../../svg/medcheck_logo';
import ArticlesMobileMenu from './articles-mobile-menu';
import ArticlesNav from './articles-nav';
import './style.scss';

export default function ArticleHeader() {
  const [openBurger, setOpenBurger] = useState(false);
  const MedchekLogo = {
    logo: (
      <>
        <Div d={{ xs: 'none', lg: 'block' }}>
          <Link to={`/`}>
            <SvgMedcheckLogoBlack />
          </Link>
        </Div>
        <Div d={{ xs: 'block', lg: 'none' }}>
          <Link to={`/`}>
            <SvgMedcheckLogo className="medcheckLogo" />
          </Link>
        </Div>
      </>
    ),
  };

  const isDocument = typeof document !== 'undefined';

  if (openBurger && isDocument) {
    document.body.style.overflow = 'hidden';
  } else if (!openBurger && isDocument) {
    document.body.style.overflow = 'visible';
  }

  return (
    <Div
      minH="60px"
      bg="white"
      pos="fixed"
      top="0"
      zIndex="100"
      w="-webkit-fill-available"
    >
      <DownloadAppBanner />
      <Container>
        <ArticlesMobileMenu className={openBurger ? 'transform' : ''} />
        <Div
          d="flex"
          p={{ y: { xs: '25px', lg: '20px' } }}
          align="center"
          justify="space-between"
        >
          <Div pos="relative" zIndex="10" maxW="210px" d="flex" align="center">
            {MedchekLogo.logo}
            <Link to="/articles">
              <Text
                className="link-bg"
                textWeight="700"
                textSize={{ xs: 'display1', sm: 'display' }}
                p={{ l: '12px' }}
                d="block"
                m={{ t: '-5px' }}
              >
                <Trans>magazine</Trans>
              </Text>
            </Link>
          </Div>
          <Div
            d={{ xs: 'flex', lg: 'block' }}
            justify={{ xs: 'flex-end', lg: 'baseline' }}
          >
            <button
              onClick={() => setOpenBurger(!openBurger)}
              className={`article-burger-button ${openBurger ? 'active' : ''}`}
            >
              <span className="article-burger-button-top"></span>
              <span className="article-burger-button-center"></span>
              <span className="article-burger-button-bottom"></span>
            </button>
            <ArticlesNav />
          </Div>
        </Div>
      </Container>
    </Div>
  );
}
